import React, { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { ColorContext } from 'App';

const Toggle = ({
  label = 'Remember me',
  value = false,
  callback,
  disabled = false,
  id = 'remember-toggle',
}) => {
  const theme = useContext(ColorContext);

  return (
    <div className="d-flex align-items-center">
      <div className="form-switch d-flex align-items-center">
        <Form.Check
          type="switch"
          id={id}
          checked={value}
          onChange={(e) => callback(e.target.checked)}
          disabled={disabled}
          className="m-0 p-2"
        />
      </div>

      <label htmlFor={id} className="user-select-none" style={{ color: theme?.fontColor }}>
        {label}
      </label>
    </div>
  );
};

export default Toggle;
